export default __webpack_public_path__ + "static/media/Spectrum-Tokens-Specs.b918304b.png";